import { render, staticRenderFns } from "./viewRanking.vue?vue&type=template&id=31322e74&"
import script from "./viewRanking.vue?vue&type=script&lang=js&"
export * from "./viewRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports